module.exports = __webpack_public_path__ + "static/media/midcityimg_mobile.44c8d519.jpg";